<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="`文件上传`"
    :name="name"
    width="640px"
    :visible.sync="visible">
     <!-- 添加水印开关 -->
    <div v-if="data.type === '23'" class="watermark-switch">
      <el-switch
        v-model="watermarkEnabled"
        active-text="添加水印"
        active-color="#13ce66">
      </el-switch>
      <el-date-picker
        size="small"
        v-model="watermarkTime"
        type="datetime"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-value="new Date()"
        placeholder="选择水印时间">
      </el-date-picker>
    </div>
    <el-upload
      ref="upload"
      class="upload-file"
      drag
      action
      :accept="accept.join(',')"
      :auto-upload="false"
      :on-change="handleChange"
      :on-remove="handleRemove"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload"
      multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">{{tip}}</div>
    </el-upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
      <el-button type="primary" @click="submitUpload" :loading="uploading">
        开始上传
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImgAddMark from '../../../utils/ImgAddMark'
import {uploadOrderReviewDirectFile} from '@/views/order-review/order-review.api'
export default {
  data () {
    return {
      name: null,
      data: {},
      callback: Function.prototype,
      success: Function.prototype,
      error: Function.prototype,
      visible: false,
      maxSize: 2048,
      fileList: [],
      uploading: false,
      questionIndex: null,
      accept: [
        'image/jpeg', 'image/png', 'image/gif',
        'audio/mp3', 'audio/wav',
        'video/mp4', 'video/webm',
      ],
      imgAddMark: null,
      watermarkEnabled: true, // 控制是否添加水印的开关
      watermarkTime: null,
    }
  },

  computed: {
    tip () {
      let acceptSuffix = this.accept.map((accept) => {
        return accept.split('/')[1]
      })
      return `只能上传 ${acceptSuffix.join('/')} 文件，且不超过 ${this.maxSize}KB`
    },
  },
  destroyed () {
    if (this.imgAddMark) {
      this.imgAddMark = null
    }
  },
  methods: {
    beforeAvatarUpload (file) {
      const isMore = file.size / 1024 / this.maxSize > 1
      if (isMore) {
        this.$message.error(`上传文件大小不能超过 ${this.maxSize}KB!`)
      }
      return !isMore
    },

    handleChange (file) {
      this.fileList = this.$refs.upload.uploadFiles
    },

    handleRemove (file) {
      this.fileList = this.$refs.upload.uploadFiles
    },

    getExtByBlob (blob) {
      return blob.name.split('.').pop().toLowerCase()
    },

    async uploadSingleFile (file) {
      try {
        const blob = file.raw || file

        // 获取签名URL
        let params = {
          orderid: this.data.orderid,
          ext: this.getExtByBlob(blob),
          content_type: blob.type,
        }
        const res = await request.common('uploadOrderReviewDirectFile', params)

        if (res.status === 200) {
          let uploadUrl = res.data.signedUrl
          let contentType = res.data.content_type
          let fileUrl = res.data.url

          // 上传文件到签名URL
          await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': contentType
            }),
            body: blob,
          })

          return {
            success: true,
            url: fileUrl
          }
        }
        return {
          success: false,
          error: '获取上传地址失败'
        }
      } catch (err) {
        return {
          success: false,
          error: err.message || '上传失败'
        }
      }
    },

    async submitUpload () {
      if (this.fileList.length === 0) {
        this.$message.warning('请选择要上传的文件')
        return
      }

      this.uploading = true
      const results = []

      try {
        for (let file of this.fileList) {
          let result = null
          if (this.data.type === '23' && this.watermarkEnabled) {
            result = await this.uploadVideoAndWatermark(file)
          } else {
            result = await this.uploadSingleFile(file)
          }
          results.push({
            file,
            name: file.name,
            ...result
          })
        }

        // 处理上传结果
        const successFiles = results.filter(r => r.success)
        const failedFiles = results.filter(r => !r.success)
        this.fileList = failedFiles.map(f => f.file)

        if (successFiles.length > 0) {
          this.success({
            urls: successFiles.map(f => f.url),
            videoThumbnailUrls: successFiles.map(f => f.videoThumbnailUrl && f.videoThumbnailUrl.length > 0 ? f.videoThumbnailUrl : null)
          })
          this.callback({
            urls: successFiles.map(f => f.url),
            videoThumbnailUrls: successFiles.map(f => f.videoThumbnailUrl && f.videoThumbnailUrl.length > 0 ? f.videoThumbnailUrl : null)
          })
        }

        if (failedFiles.length > 0) {
          const failedNames = failedFiles.map(f => f.name).join(', ')
          this.$message.error(`以下文件上传失败: ${failedNames}`)
          this.error(new Error('部分文件上传失败'))
        }

        if (failedFiles.length === 0) {
          this.visible = false
        }
      } catch (err) {
        this.$message.error('上传过程发生错误')
        this.error(err)
      } finally {
        this.uploading = false
      }
    },
    // 上传视频和水印封面
    async uploadVideoAndWatermark (file) {
      try {
        const blob = file.raw || file
        let videoThumbnailUrl = null
        this.imgAddMark = new ImgAddMark()
        const firstFrame = await this.imgAddMark.getVideoFirstFrame(blob)
        const watermarkedBlob = await this.imgAddMark.addWatermarkToImage(firstFrame, this.data.imgUrl, this.watermarkTime)
        let ImgUploadParams = {
          url: this.imgAddMark.getRemarkUrl(this.data.imgUrl, this.questionIndex),
          content_type: watermarkedBlob.type,
        }
        videoThumbnailUrl = await this.uploadOrderDirectFile(ImgUploadParams, watermarkedBlob)
        let videoUploadParams = {
          url: this.imgAddMark.getVideoRemarkUrl(this.data.imgUrl, this.questionIndex, blob.duration),
          content_type: blob.type,
        }
        let videoUrl = await this.uploadOrderDirectFile(videoUploadParams, blob)
        return {
          success: true,
          url: videoUrl,
          videoThumbnailUrl: videoThumbnailUrl,
        }
      } catch (err) {
        console.log(err)
        return {
          success: false,
          error: err.message || '上传失败',
          videoThumbnailUrl: null
        }
      }
    },
    // 直传
    async uploadOrderDirectFile (params, file) {
      return new Promise(async (resolve, reject) => {
        file.loading = true
        const res = await uploadOrderReviewDirectFile(params)
        if (res.data.ret === 0) {
          let uploadUrl = res.data.detail.signedUrl
          let contentType = res.data.detail.content_type
          let fileUrl = res.data.detail.url
          await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({
              'Content-Type': contentType
            }),
            body: file,
          })
          resolve(fileUrl)
        } else {
          reject(new Error('上传失败'))
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.upload-file {
  .el-upload-dragger {
    width: 500px;
  }
}
</style>
<style lang="scss" scoped>
.watermark-switch {
  position: absolute;
  bottom: 40px;
  left: 20px;
  z-index: 10;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/UploadFile/src/main.vue